<template>
  <div class="training-school">
    <div class="training-school-inner">
      <el-table :data="QuestionList" border height="440" style="width: 100%;">
        <!-- <el-table-column
              min-width="100"
              show-overflow-tooltip
              :label="'进度'"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.percentage==100">已完成</el-tag>
                <el-tag type="danger" v-else>未完成</el-tag>
              </template>
        </el-table-column>-->
        <el-table-column min-width="100" show-overflow-tooltip :label="'资源格式'" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.documentType==1">文档</span>
            <span v-else-if="scope.row.documentType==3">图片</span>
            <span v-else-if="scope.row.documentType==4">音频</span>
            <span v-else>视频</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="360px"
          prop="name"
          show-overflow-tooltip
          align="center"
          label="名称"
        ></el-table-column>

        <!-- <el-table-column
                prop="jzName"
                min-width="100px"
                align="center"
                label="警种">
        </el-table-column>-->

        <el-table-column prop="createTime" min-width="150px" align="center" label="创建时间"></el-table-column>
        <el-table-column prop="deptName" min-width="220px" align="center" label="部门"></el-table-column>
        <!-- <el-table-column
                prop="score"
                min-width="100px"
                align="center"
                label="分值">
            </el-table-column>
            <el-table-column
            align="center"
            :label="'操作'"
            min-width="120px"
          >
            <template slot-scope="scope">
              <el-button type="primary" plain size="mini" @click="newsVideo(scope.row)">立即学习</el-button>
            </template>
        </el-table-column>-->
      </el-table>
    </div>
    <el-dialog
      title="预览"
      :visible.sync="taskDialog"
      width="80%"
      destroy-on-close
      class="dialog-mini"
    >
      <PreviewCourse v-if="taskDialog" @auditResou="auditResou" :resourlist="resourlist"></PreviewCourse>
    </el-dialog>
    <el-dialog
      class="dialog-mini"
      title="查看"
      :visible.sync="dialogVisiblea"
      width="70%"
      v-if="dialogVisiblea"
    >
      <iframe :src="worksauditurl" style="width:100%;height:600px" v-if="worksauditType==1"></iframe>
      <div v-else-if="worksauditType==2">
        <video
          ref="hlsVideo"
          preload="auto"
          style="width: 100%; height:600px"
          id="videoPlayer"
          class="video-js vjs-default-skin"
        >
          <source :src="worksauditurl" type="application/x-mpegURL" />
        </video>
      </div>
      <div v-else-if="worksauditType==4" style="text-align: center;">
        <div style="font-size:24px">音频名称:{{worksauditName}}</div>
        <audio controls style="margin-top:10px">
          <!-- <source src="horse.ogg" type="audio/ogg"> -->
          <source :src="worksauditurl" type="audio/mpeg" />
        </audio>
      </div>
      <div v-else-if="worksauditType==3" style="text-align: center;">
        <div style="font-size:24px">图片名称:{{worksauditName}}</div>
        <div style="width: 100%;text-align: center;">
          <img :src="worksauditurl" alt style=" max-width: 100%;max-height: 100%;" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as apiTrainPeople from '@/api/train/trainPeople';
import PreviewCourse from './previewCourse';
import * as resourceapp from '@/api/resources/index.js';
import { getInfo } from '@/utils/auth';

export default {
  props: ['trainId'],
  components: {
    PreviewCourse,
  },
  data() {
    return {
      QuestionList: [],
      levels: 5,
      tabActive: 0,
      tablist: [
        {
          title: '五星级精品',
          id: 5,
        },
        {
          title: '四星级精品',
          id: 4,
        },
      ],
      taskDialog: false,
      resourlist: {},
      resourceList: {},
      dialogVisiblea: false,
      argumentAudit: '',
      worksauditId: '',
      worksauditType: '',
      worksauditurl: '',
      worksauditName: '',
      handleUpdaterow: '',
      score: '',
    };
  },
  mounted() {
    this.MoocQuestionList();
  },
  methods: {
    //跳转到新页面进入视频的播放
    newsVideo(row) {
      //  this.$router.push('/personCenter/videoleam?trainid=' +this.trainId);

      if (row.objtype == 2) {
        sessionStorage.setItem('trainId', this.trainId);
        this.$router.push({
          path: '/studyclassDetail',
          query: {
            id: row.objId,
            trainId: this.trainId,
          },
        });
      } else if (row.objtype == 1) {
        sessionStorage.setItem('trainId', this.trainId);

        this.$router.push({
          path: '/sourceslist/videoLearn',
          query: {
            id: row.objId,
            trainId: this.trainId,
          },
        });
      }
      if (getInfo('tokens')) {
      } else {
        window.clikLogin();
      }
    },
    getVideo() {
      videojs(
        'videoPlayer',
        {
          bigPlayButton: false,
          textTrackDisplay: false,
          posterImage: false,
          errorDisplay: false,
          controls: true,
          hls: {
            withCredentials: true,
          },
        },
        function () {
          this.play();
        }
      );
    },
    selectRoursce(row) {
      resourceapp.getById({ id: row.objId }).then((res) => {
        this.resourceList = res.result;
        let rows = this.resourceList;
        this.dialogVisiblea = true;
        this.worksauditurl = rows.filePath;
        this.worksauditId = rows.id;
        this.argumentAudit = rows.auditMsg;
        this.score = rows.grade;
        this.worksauditType = rows.documentType;
        this.worksauditName = rows.name;
        if (rows.documentType == 2) {
          this.$nextTick(function () {
            this.getVideo();
          });
        }
      });
    },
    //预览
    handleSelect(row) {
      if (row.objId) {
        row.id = row.objId;
      }
      this.resourlist = row;
      this.taskDialog = true;
    },
    // 更多
    acadMore() {
      this.$router.push('/mooc/policeAcademyMore');
    },
    MoocQuestionList() {
      let data = {
        trainId: this.trainId,
        objType: 2,
      };
      apiTrainPeople.getListCourse(data).then((res) => {
        this.QuestionList = res.data;
      });
    },
    // //跳转到新页面进入视频的播放
    // newsVideo(id) {
    //   this.$router.push('/studyclassDetail?id=' + id);
    // },
    tabHandleChange(index, id) {
      this.tabActive = index;
      this.levels = id;
      this.$emit('tabChange', this.tabActive);
      this.MoocQuestionList();
    },
  },
};
</script>

<style lang="scss" scoped>
.training-school {
  min-height: 250px;
  > .training-school-inner {
    border-radius: 6px;
    background-color: #fff;
    padding-left: 20px;
    .trainingvideo {
      display: flex;
      .trainingvideright {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        .trainingimgli {
          width: 270px;
          border: 1px solid rgba(242, 242, 242, 1);
          margin: 0 10px 20px 10px;
          border-radius: 6px;
          img {
            width: 100%;
            height: 136px;
            border-radius: 6px 6px 0 0;
          }
          .traingimgtext {
            display: flex;
            align-items: center;
            font-size: 16px;
            color: #666;
            margin-top: 6px;
            padding-left: 10px;
          }
          .traingimgnametxtlil {
            color: #999;
            font-size: 14px;
            display: flex;
            margin-top: 6px;
            padding-bottom: 10px;
            padding-left: 10px;
            .traingimgname {
              padding: 3px 5px;
              color: #fff;
              background-color: #4876c4;
              border-radius: 4px;
              font-size: 13px;
              margin-right: 8px;
            }
            .traniBox {
              flex: 1;
              display: flex;
              .trainicon {
                flex: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                  width: 16px;
                  height: 16px;
                  margin-right: 2px;
                }
              }
            }
          }
        }
      }
    }
  }
}

.gdbox {
  display: flex;
  align-items: center;
  line-height: 50px;
  .gdtext {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    opacity: 1;
  }
  .gdimg {
    margin: 0 10px 0 8px;
  }
}

.play-btn {
  font-size: 50px;
  color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  &:hover {
    cursor: pointer;
  }
}
.nodata-boxs {
  margin-left: 408px;
  margin-top: 50px;
}
</style>
